/* eslint-disable import/prefer-default-export */
export const properties = state => id => {
    const selectedForm = state.forms.find(form => form.id === id);
    return selectedForm ? selectedForm.properties : null;
};

export const hasForm = state => id => {
    return state.forms.some(form => form.id === id);
};

export const hasRoute = state => route => {
    const formInRouteRegex = new RegExp(`^${route}__[a-zA-Z]+`);
    return state.forms.some(form => form.id.match(formInRouteRegex));
};
